import { AxiosResponse } from 'axios';
import RequestResourceSuccessById from 'ia-react-core/~/actions/resource/RequestResourceSuccessById';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import requestResourceSuccessById from '../../../actions/resource-fn/requestResourceSuccessById';
import { ResourceGroupComposedProps } from './ResourceGroup';

export default function resourceGroupDataReducer(state: Object, action: CoreAction, { resourceId, transformResponsesData }: ResourceGroupComposedProps<any, any, any>) {
  switch (action.type) {
    case `${requestResourceSuccessById.type}/${resourceId}`:
      return reduceRequestData(state, action as RequestResourceSuccessById, transformResponsesData);
    default:
      return state;
  }
}

function reduceRequestData(state: Object, { request: requests }: RequestResourceSuccessById, transformResponsesData = (data: Object) => data) {
  return transformResponsesData(formatRequestsData(requests as { request: AxiosResponse; name: string }[]));
}

function formatRequestsData(requests: { request: AxiosResponse; name: string }[]) {
  return requests.reduce<Record<string, unknown>>((currentData, { name, request }) => {
    currentData[name.replace(/resources./, '')] = Array.isArray(request) ? formatRequestsData(request) : request.data;
    return currentData;
  }, {});
}
